import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import BreadcrumbToolbar from './BreadcrumbToolbar';
import LoadingPanel from '../../components/LoadingPanel';

class PageWrapperV2 extends Component {
  render() {
    const {
      children,
      helmetTitle,
      isLoadingPage,
    } = this.props;
    const breadcrumbs = [
      {
        id: 'HomeCgn',
        label: 'Home',
        selectable: true,
      },
      {
        id: 'ListaDomandeAnf',
        label: 'Assegno nucleo familiare',
        selectable: false,
      }];
    return (
      <div className="page__wrapper__container">
        {helmetTitle && <Helmet title={helmetTitle} /> }
        <LoadingPanel isLoading={isLoadingPage || false}>
          <div className="page__wrapper">
            <div className="toolbar__container">
              <BreadcrumbToolbar
                breadcrumbs={breadcrumbs}
              >
                <BreadcrumbToolbar.ButtonGroup />
              </BreadcrumbToolbar>
            </div>
            <div className="page__container">
              {children}
            </div>
          </div>
        </LoadingPanel>
      </div>
    );
  }
}

PageWrapperV2.defaultProps = {
  children: null,
  helmetTitle: null,
  isLoadingPage: false,
  onPageBack: null,
  pageActions: null,
  pageBack: false,
  pageButtons: null,
};

PageWrapperV2.propTypes = {
  children: PropTypes.element,
  helmetTitle: PropTypes.string,
  isLoadingPage: PropTypes.bool,
  onPageBack: PropTypes.func,
  pageActions: PropTypes.element,
  pageBack: PropTypes.bool,
  pageButtons: PropTypes.element,
  pageTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(PageWrapperV2);
